import {PIFK, POFK} from "../../../const/form-field.const";
import {array, object, string} from 'yup';

let purchaseInvoiceSchema:any= object({
    [PIFK.SUPPLIER_CODE]:string().required('Supplier code is required'),
});

export default purchaseInvoiceSchema